import {
    ColumnFactory,
    ComponentManager,
    ImageViewModel,
    LabelViewModel,
    Image as ImageControl,
    Utilities,
    GlobalConfiguration,
} from 'radpresentation.htmlclient.defaultviewextensions';
class DataTypeColumnFactory extends ColumnFactory {
    private default: string;
    private isDynamic: boolean;
    private visibleObs: KnockoutObservable<boolean>;
    private $div: JQuery;
    private tooltip: string;

    static isPlainText = false;
    static isJQueryElement = true;

    constructor(params: any) {
        super(params);

        this.isDynamic = params.isDynamic;
        this.visibleObs = params.visibleObs;
        this.default = params.default;
        this.tooltip = params.tooltip;

        if (this.visibleObs) {
            this.defineComputed(() => {
                let isVisible = this.visibleObs();
                if (this.$div) {
                    this.$div[isVisible ? 'removeClass' : 'addClass'](
                        'staticProperty'
                    );
                }
            });
        }
    }

    private static sourceByDataType = {
        boolean: 'boolean.png',
        'Multilingual String': 'mlstring.png',
        Serial: 'mlstring.png',
        String: 'string.png',
        DateTime: 'datetime.png',
        DatePicker: GlobalConfiguration.inlineImages.DATEPICKER,
        DateAndTimePicker: 'datetimepicker.png',
        ToOneAssociation: 'to_one_association.png',
        ToManyAssociation: 'to_many_association.png',
        TextBox: 'textbox.png',
        CheckBox: 'checkbox.png',
        Label: 'label.png',
        DataTypeEmptyGroupBox: 'group_box.png',
        NumericTextBox: 'numericbox.png',
        Currency: 'currency.png',
        CurrencyT: 'currency.png',
        CurrencyTextBox: 'currency.png',
    };

    public getValue(): any {
        if (this.$div) {
            return this.$div;
        }

        let dataType = this.raw;
        let source =
            DataTypeColumnFactory.sourceByDataType[dataType] ||
            DataTypeColumnFactory.sourceByDataType[
                dataType.split('&lt;Nullable&gt;').pop().trim()
            ] ||
            this.default;

        let imageViewModel = new ImageViewModel({
            source: source,
            alternativeText: new LabelViewModel({
                caption: dataType,
            }),
        });
        let imageControl = new ImageControl(imageViewModel);
        let $image = imageControl.getControl();

        imageControl.dispose();
        imageViewModel.dispose();

        let $text = $('<span>' + this.raw + '</span>');
        let $both = $image.add($text);

        let $div = $('<div>').append($both);

        if (
            (this.visibleObs && !this.visibleObs()) ||
            (!this.visibleObs && !this.isDynamic)
        ) {
            $div.addClass('staticProperty');
        }

        if (Utilities.isNotBlank(this.tooltip)) {
            ko.applyBindingsToNode($div[0], {
                tooltip: new LabelViewModel({ caption: this.tooltip }),
            });
        }

        this.$div = $div;
        return $div;
    }
}

export default DataTypeColumnFactory;
ComponentManager.setFactory(
    'DataTypeColumnFactory',
    DataTypeColumnFactory,
    'RADExtensionManagerHTMLViewExtension'
);
ComponentManager.setFactory(
    'DataTypeColumn',
    DataTypeColumnFactory,
    'RADExtensionManagerHTMLViewExtension'
);
